import React from 'react';

function Stats(props) {
    return (    
            <iframe title="stats-iframe" className = "iframe-template-1" src={props.url}></iframe>           
    );
}

export default Stats;